import { BRAND } from "constants/action-types";
import siteConfig from "site-config";
import { progressEpic } from "epics/base-epic";
import { snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";

export const updateOrderSettingsEpic = progressEpic(
    BRAND.ORDER_SETTINGS.UPDATE,
    ({ payload }) => ({
        method: "POST",
        url: `${siteConfig.api}/brand/order-settings`,
        body: payload,
    }),
    {
        finishActions: () => [snackbarAdd({ message: format("Preferences Updated") })],
    }
);
